import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getCardActivateDetails,
    getAlGroupsForDropdown,
    getAllOperationEntitiesForDropDown,
    GetCollectionPointsFilter,
    updateStatus,
    GetAllEmployeeTypes,
    getOperationEntitiesByGroupForDropDown
};

async function getAlGroupsForDropdown() {
    var groupArray = [];

    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }

    return groupArray;
}
async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getAllOperationEntitiesForDropDown(groupID) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function GetCollectionPointsFilter(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointByOperationEntityId', 'operationEntityID=' + operationEntityID);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function getCardActivateDetails(collectionPointID, employeeTypeID, isRsm) {
    const res = await CommonGet('/api/EmployeeCardManagement/GetEmployeeCardsToActivate', 'collectionPointID=' + collectionPointID + '&employeeTypeID=' + employeeTypeID + '&isRsm=' + isRsm);
    return res.data;
}

async function updateStatus(cardUpdate) {
    const response = await CommonPost('/api/EmployeeCardManagement/UpdateEmployeeCardsToActivation', null, cardUpdate);
    return response;
}

async function GetAllEmployeeTypes() {
    var typeArray = [];
    const response = await CommonGet('/api/Employee/GetAllEmployeeTypes', null)
    for (let item of Object.entries(response.data)) {
        typeArray[item[1]["employeeTypeID"]] = item[1]["employeeTypeName"]
    }
    return typeArray;
}
